import { Box, Button, Grid, Stack, TextField, Typography } from '@mui/material'
import CMSHeader from 'components/CMSHeader/CMSHeader'
import { WebsiteInput } from 'graphql/types'
import { Controller, useForm } from 'react-hook-form'
import { useStoreActions, useStoreState } from 'store/hooks'

interface WebsiteSettingsInput {
    Name: string
    PreviewURL: string
    ElementDefinitions: string
}

const WebsiteCreatePage = (): JSX.Element => {
    const websiteCreate = useStoreActions((actions) => actions.model.websiteCreate)
    const websiteList = useStoreState((state) => state.model.websiteList)
    const selectedWebsite = useStoreState((state) => state.model.selectedWebsite)
    const setSelectedWebsite = useStoreActions((actions) => actions.model.setSelectedWebsite)
    const unpublishedItems = useStoreState((state) => state.model.unpublishedItems)

    const { handleSubmit, control } = useForm<WebsiteSettingsInput>({
        mode: 'onSubmit',
        reValidateMode: 'onBlur',
        defaultValues: {
            Name: '',
            PreviewURL: '',
            ElementDefinitions: '',
        },
    })

    const createWebsite = () => {
        handleSubmit((data: WebsiteSettingsInput) => {
            const ws: WebsiteInput = {
                id: '',
                createdAt: new Date().getTime(),
                name: data.Name,
                previewURL: data.PreviewURL,
                elementDefinitions: data.ElementDefinitions,
            }
            websiteCreate(ws)
        })()
    }

    return (
        <>
            <CMSHeader
                unpublishedItems={unpublishedItems}
                selectedWebsite={selectedWebsite?.id ?? ''}
                websiteList={websiteList}
                onSelectWebsite={setSelectedWebsite}
            />

            <Box display="flex" flexDirection="column" flex={1} p={2}>
                <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={2}>
                    <Typography variant="h6">Website erstellen</Typography>
                </Grid>
                <Grid container mb={2}>
                    <Controller
                        name="Name"
                        control={control}
                        rules={{
                            required: 'Bitte geben Sie einen Name an',
                            maxLength: { value: 150, message: 'Der Name darf nur 150 Zeichen lang sein' },
                        }}
                        render={({ field, fieldState }) => (
                            <TextField
                                label="Name"
                                fullWidth={true}
                                {...field}
                                inputProps={{ maxLength: 150 }}
                                helperText={fieldState.error?.message ?? ''}
                            />
                        )}
                    />
                </Grid>
                <Grid container mb={2}>
                    <Controller
                        name="PreviewURL"
                        control={control}
                        rules={{
                            required: 'Bitte geben Sie eine PreviewURL an',
                            maxLength: { value: 150, message: 'Die PreviewURL darf nur 150 Zeichen lang sein' },
                        }}
                        render={({ field, fieldState }) => (
                            <TextField
                                label="PreviewURL"
                                fullWidth={true}
                                {...field}
                                inputProps={{ maxLength: 150 }}
                                helperText={fieldState.error?.message ?? ''}
                            />
                        )}
                    />
                </Grid>
                <Grid container mb={2}>
                    <Controller
                        name="ElementDefinitions"
                        control={control}
                        render={({ field }) => {
                            return (
                                <TextField
                                    multiline
                                    minRows={4}
                                    maxRows={20}
                                    {...field}
                                    fullWidth={true}
                                    label="Element Definitions"
                                    variant={'filled'}
                                />
                            )
                        }}
                    />
                </Grid>
                <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                    <Button variant="contained" onClick={createWebsite}>
                        Create
                    </Button>
                </Stack>
            </Box>
        </>
    )
}

export default WebsiteCreatePage
